module.exports = __webpack_public_path__ + "img/ObenNebenFuesseSeiteTransp.bea076d7.png";